@if (item) {
  <form [formGroup]="form">
    <div>
      <ion-card class="ion-no-padding ion-no-margin">
        <ion-card-content class="ion-no-padding">
          <ion-list lines="full" class="ion-no-padding">
            <ion-item>
              <ion-input label="Name" labelPlacement="floating" required="true" formControlName="name"
              (ionBlur)="updateName()" data-testid="beer-form-name"></ion-input>
              @if (!!externalApiSettings?.untappd && isPremium) {
                <ion-button (click)="openSeachModalUntappd()" slot="end" fill="clear" shape="round">
                  <ion-avatar>
                    <img src="/assets/images/companies/untappd-logo.webp" />
                  </ion-avatar>
                </ion-button>
              }
              @if (!!externalApiSettings?.brewfather && isPremium) {
                <ion-button (click)="openSeachModalBrewfather()" slot="end" fill="clear" shape="round" data-testid="beer-form-brewfather-btn">
                  <ion-avatar>
                    <img src="/assets/images/companies/brewfather-logo.webp" />
                  </ion-avatar>
                </ion-button>
              }
            </ion-item>
            <ion-item>
              <ion-textarea label="Description" labelPlacement="floating" formControlName="description"
              (ionBlur)="updateDescription()" rows="6" data-testid="beer-form-description"></ion-textarea>
            </ion-item>
            <ion-item>
              <ion-input label="Checkin Url" labelPlacement="floating" formControlName="checkinUrl"
              (ionBlur)="updateCheckinUrl()" data-testid="beer-form-checkin-url"></ion-input>
            </ion-item>
            @if (allBeerStyles) {
          <ion-item button="true" (click)="selectBeerstyle.open()"  data-testid="beer-form-beerstyle-trigger">
                <ion-label>Beer Style</ion-label>
                <app-select-beerstyle #selectBeerstyle [selected]="item.beerStyle ?? undefined"
                  [allBeerstyles]="allBeerStyles" (update)="updateBeerstyle($event)"
                  (deleteItem)="deleteBeerstyle.emit($event)"
                (addItem)="addBeerstyle.emit({ barId: item.barId, name: $event })"></app-select-beerstyle>
              </ion-item>
            }
            <ion-item>
              <ion-icon slot="end" size="large" name="ellipse-sharp" class="ion-align-self-center"
              [style.color]="item.color" data-testid="beer-form-color-indicator"></ion-icon>
              <ion-input label="SRM" labelPlacement="floating" formControlName="srm" (ionBlur)="updateSrm()"
              type="number" data-testid="beer-form-srm"></ion-input>
            </ion-item>
            <ion-item>
              <ion-input label="FG (Final Gravity)" labelPlacement="floating" formControlName="fg" (ionBlur)="updateFg()"
              type="number" data-testid="beer-form-fg"></ion-input>
            </ion-item>
            <ion-item>
              <ion-input label="ABV %" labelPlacement="floating" formControlName="abv" (ionBlur)="updateAbv()"
              type="number" data-testid="beer-form-abv"></ion-input>
            </ion-item>
            <ion-item>
              <ion-input label="IBU" labelPlacement="floating" formControlName="ibu" (ionBlur)="updateIbu()"
              type="number" data-testid="beer-form-ibu"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label>Rating</ion-label>
              <app-rating slot="end" [rating]="item.rating ?? 0" (ratingChange)="updateRating($event)"></app-rating>
            </ion-item>
            <app-image-label
              [item]="item"
              [barId]="item.barId"
              (softUpdate)="updateLabel($event)"
            ></app-image-label>
          </ion-list>
        </ion-card-content>
      </ion-card>
    </div>
    <!--
    <ion-card>
      <ion-card-header>
        <ion-card-title>Label</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <app-picture-cropper
          *ngIf="item"
          label="Label"
          labelPosition="full"
          pathFolder="media/beerlabels"
          [inputImageUrl]="item.image ?? ''"
          (formSubmitted)="updateLabel($event)"
          [barId]="item.barId"
        ></app-picture-cropper>
      </ion-card-content>
    </ion-card> -->
    <!-- Location -->
    <!--
    <div class="ion-padding-top" *ngIf="locations">
      <ion-text color="medium">
        <h6>Location</h6>
      </ion-text>
      <ion-card class="ion-no-padding ion-no-margin">
        <ion-card-content class="ion-no-padding">
          <ion-item lines="full">
            <ion-select
              label="Location"
              labelPlacement="floating"
              formControlName="location"
              interface="popover"
              (ionChange)="updateLocation($event)"
              >
              <ion-select-option value="">Choose location</ion-select-option>
              <ion-select-option
                *ngFor="let location of locations"
                [value]="location.id"
                >
                {{ location.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-card-content>
      </ion-card>
    </div> -->
    <!-- Dates -->
    <!-- <div class="ion-padding-top">
    <ion-text color="medium">
      <h6>Dates</h6>
    </ion-text>
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        <ion-item lines="full">
          <ion-label>Bottle Date</ion-label>
          <ion-datetime-button *ngIf="bottleDate" slot="end" datetime="bottleDate"></ion-datetime-button>
          <ion-button *ngIf="!item.bottleDate" (click)="setDefaultBottleDate()" slot="end" fill="clear" shape="round" color="success">
            <ion-icon name="add-circle-outline" slot="icon-only"></ion-icon>
          </ion-button>
          <ion-button *ngIf="item.bottleDate" (click)="deleteBottleDate()" slot="end" fill="clear" shape="round" color="danger">
            <ion-icon name="trash-outline" slot="icon-only">
            </ion-icon>
          </ion-button>
          <ion-modal [keepContentsMounted]="true">
            <ng-template>
              <ion-datetime *ngIf="bottleDate" presentation="date" [value]="bottleDate" size="cover" id="bottleDate"
                (ionChange)="setBottleDate($event)" showDefaultButtons="true">
                <span slot="title">Bottle Date</span>
              </ion-datetime>
            </ng-template>
          </ion-modal>
        </ion-item>
        <ion-item lines="none">
          <ion-label>Best Before Date</ion-label>
          <ion-datetime-button *ngIf="bestBeforeDate" slot="end" datetime="bestBeforeDate"></ion-datetime-button>
          <ion-button *ngIf="!item.bestBeforeDate" (click)="setDefaultBestBeforeDate()" slot="end" fill="clear" shape="round" color="success">
            <ion-icon name="add-circle-outline" slot="icon-only"></ion-icon>
          </ion-button>
          <ion-button *ngIf="item.bestBeforeDate" (click)="deleteBestBeforeDate()" slot="end" fill="clear" shape="round" color="danger">
            <ion-icon name="trash-outline" slot="icon-only">
            </ion-icon>
          </ion-button>
          <ion-modal [keepContentsMounted]="true">
            <ng-template>
              <ion-datetime *ngIf="bestBeforeDate" presentation="date" [value]="bestBeforeDate" size="cover"
                id="bestBeforeDate" (ionChange)="setBestBeforeDate($event)" showDefaultButtons="true">
                <span slot="title">Best Before Date</span>
              </ion-datetime>
            </ng-template>
          </ion-modal>
        </ion-item>
      </ion-card-content>
    </ion-card>
  </div> -->
  @if (allKegs) {
    <div class="ion-padding-top">
      <div class="ion-display-flex ion-flex-row ion-align-items-center ion-justify-content-between">
        <ion-text color="medium">
          <h6>Kegs</h6>
        </ion-text>
        <ion-button color="success" size="small" fill="solid" shape="round" (click)="openAddKegModal(null)">
          <ion-icon slot="end" name="add-outline"> </ion-icon>
          Add
        </ion-button>
      </div>
      <ion-card class="ion-no-padding ion-no-margin">
        @if (unitTypes) {
          <ion-card-content class="ion-no-padding">
            @for (keg of attachedKegs; track trackKegById(i, keg); let i = $index) {
              <ion-item
                lines="full"
                (click)="openAddKegModal(keg)"
                button="true"
                >
                <ion-label>
                  {{ keg.name }}
                  {{ keg.tap?.plaato?.name ? " - " + keg.tap?.plaato?.name : "" }}
                  {{ keg.tap?.kegtron?.name ? " - " + keg.tap?.kegtron?.name : "" }}
                  {{
                  keg.tap?.customKegMon?.name
                  ? " - " + keg.tap?.customKegMon?.name
                  : ""
                  }}
                  <ul class="item-list item-list-inline color-medium">
                    <li>
                      <small>Size: {{ keg.size }} {{ unitTypes.kegs }}</small>
                    </li>
                    <li>
                      <small
                        >Amount left: {{ keg.amount }} {{ unitTypes.kegs }}
                      </small>
                    </li>
                    @if (keg.bestBeforeDate) {
                      <li>
                        <small
                          >Best:
                          {{ dateHelper.formatDate(keg.bestBeforeDate, "MMM yyyy") }}
                        </small>
                      </li>
                    }
                    @if (keg.locationId) {
                      <li>
                        <small>Location: {{ keg.location?.name }} </small>
                      </li>
                    }
                  </ul>
                </ion-label>
                <ion-button (click)="confirmDeleteKeg(keg, i);$event.stopPropagation();" slot="end" fill="clear" shape="round" color="danger" size="default">
                  <ion-icon
                    size="small"
                    name="trash-outline"
                    slot="icon-only"
                    >
                  </ion-icon>
                </ion-button>
              </ion-item>
            }
          </ion-card-content>
        }
      </ion-card>
    </div>
  }
  <div class="ion-padding-top">
    <div class="ion-display-flex ion-flex-row ion-align-items-center ion-justify-content-between">
      <ion-text color="medium">
        <h6>Bottles</h6>
      </ion-text>
      <ion-button color="success" size="small" fill="solid" shape="round"
        (click)="openAddBottleModal()" data-testid="form-add-bottle">
        <ion-icon name="add-outline" slot="end"></ion-icon>
        Add
      </ion-button>
    </div>
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        @for (bottle of bottles(); track bottle; let i = $index) {
          <ion-item
            lines="full"
            button="true"
            (click)="openEditBottleModal(bottle.id ?? '')"
            data-testid="form-bottle-item"
            [attr.data-bottle-name]="bottle.name"
            >
            <ion-label>
              {{ bottle.name }}
              <ul class="item-list item-list-inline color-medium">
                <li>
                  <small>{{ bottle.count }} bottles </small>
                </li>
                @if (bottle.bestBeforeDate) {
                  <li data-testid="form-bottle-best-row">
                    <small
                      >Best:
                      {{ dateHelper.formatDate(bottle.bestBeforeDate, "MMM yyyy") }}
                    </small>
                  </li>
                }
                @if (bottle.notify && bottle.notificationDate) {
                  <li data-testid="form-bottle-alert-row">
                    <ion-text color="danger">
                      <small>
                        Alert:
                        {{
                        dateHelper.momentCalendarWithoutTime(
                        bottle.notificationDate
                        )
                        }}
                      </small>
                    </ion-text>
                  </li>
                }
                @if (bottle.locationId) {
                  <li data-testid="form-bottle-location-row">
                    <small>
                      <ion-icon
                        src="assets/icons/flat/beer/hogshead.svg"
                        slot="start"
                      ></ion-icon>
                      {{ getLocationName(bottle.locationId) }}
                    </small>
                  </li>
                }
              </ul>
            </ion-label>
            <ion-button (click)="confirmDeleteBottle(bottle);$event.stopPropagation();" slot="end" fill="clear" shape="round" color="danger" size="default" data-testid="form-bottle-delete">
              <ion-icon size="small" slot="icon-only" name="trash-outline">
              </ion-icon>
            </ion-button>
          </ion-item>
        }
      </ion-card-content>
    </ion-card>
  </div>
  @if (item) {
    <div class="ion-padding-top">
      <div class="ion-display-flex ion-flex-row ion-align-items-center ion-justify-content-between">
        <ion-text color="medium">
          <h6>Cans</h6>
        </ion-text>
        <ion-button color="success" size="small" fill="solid" shape="round" (click)="openAddCanModal()" data-testid="form-add-can">
          <ion-icon slot="end" name="add-outline"> </ion-icon>
          Add
        </ion-button>
      </div>
      <ion-card class="ion-no-padding ion-no-margin">
        <ion-card-content class="ion-no-padding">
          @for (can of cans(); track can; let i = $index) {
            <ion-item lines="full" (click)="openEditCanModal(can.id ?? '')" button="true"
              data-testid="form-can-item" [attr.data-can-name]="can.name">
              <ion-label>
                {{ can.name }}
                <ul class="item-list item-list-inline color-medium">
                  <li>
                    <small>{{ can.count }} cans </small>
                  </li>
                  @if (can.bestBeforeDate) {
                    <li data-testid="form-can-best-row">
                      <small
                        >Best:
                        {{ dateHelper.formatDate(can.bestBeforeDate, "MMM yyyy") }}
                      </small>
                    </li>
                  }
                  @if (can.notify && can.notificationDate) {
                    <li data-testid="form-can-alert-row">
                      <ion-text color="danger">
                        <small>
                          Alert:
                          {{
                          dateHelper.momentCalendarWithoutTime(can.notificationDate)
                          }}
                        </small>
                      </ion-text>
                    </li>
                  }
                  @if (can.locationId) {
                    <li>
                      <small>
                        <ion-icon
                          src="assets/icons/flat/beer/hogshead.svg"
                          slot="start"
                        ></ion-icon>
                        {{ getLocationName(can.locationId) }}
                      </small>
                    </li>
                  }
                </ul>
              </ion-label>
              <ion-button (click)="confirmDeleteCan(can);$event.stopPropagation();" slot="end" fill="clear" shape="round" color="danger" size="default" data-testid="form-can-delete">
                <ion-icon
                  size="small"
                  name="trash-outline"
                  slot="icon-only"
                  >
                </ion-icon>
              </ion-button>
            </ion-item>
          }
        </ion-card-content>
      </ion-card>
    </div>
  }
  <!-- END CONTENT -->
</form>
}
